// Utility helpers for RankedHorizontalBarChartComponent

export function lightenColor(hex: string, amount: number): string {
  if (!hex || typeof hex !== 'string') return hex;
  const clean = hex.replace('#','');
  if (clean.length !== 6) return hex;
  const num = parseInt(clean, 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;
  const lighten = (c: number) => Math.min(255, Math.round(c + (255 - c) * amount));
  const nr = lighten(r), ng = lighten(g), nb = lighten(b);
  return '#' + [nr, ng, nb].map(v => v.toString(16).padStart(2,'0')).join('');
}

export function parsePercent(value: any, label?: string): number {
  let v: number | undefined;
  if (typeof value === 'number') v = value;
  if (v === undefined && typeof value === 'string') v = parseFloat(value.replace('%',''));
  if (v === undefined && label) v = parseFloat(String(label).replace('%',''));
  if (v === undefined || isNaN(v)) return 0;
  if (v <= 1) v = v * 100;
  return Math.max(0, Math.min(100, v));
}

export const COLOR_PALETTE = [
  '#2E5AAC', '#0074D9', '#00A0C6', '#04BFBF', '#199E59', '#D9A400', '#E0A619', '#E66F00', '#FF8C42', '#B36B00', '#5F6A89', '#3A8FB7', '#41BBD9', '#65789B', '#61DDAA'
];
